import { memo } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";

function Export2Excel({ users = [] }) {
  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  const downloadCsvData = users?.map((res) => ({
    fullName: res?.fullName,
    EmailAddress: res?.email,
    ContactNumber: res?.contact || "NA",
    Role: res?.accessLevel,
    PasswordReset: res?.passwordReset ? "Yes" : "No",
    RegistrartionDate: moment(res?.website).format("DD/MM/YYYY hh:mm a"),
  }));

  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        exportToCSV(downloadCsvData, "User List");
      }}
      style={{ float: "right" }}
      href="/add-report"
      className="btn btn-primary mr-1"
    >
      <i
        className="fa fa-file-excel-o"
        style={{ color: "black", fontWeight: "bold" }}
      ></i>
    </a>
  );
}

export default memo(Export2Excel);
